import {
  selectIncident,
  selectIncidents,
  useAppSelector,
} from 'slices/commonSelectors';

export function useWorkspaceName(
  incidentId?: string | null,
  incidentName?: string | null
) {
  const incidents = useAppSelector(selectIncidents);
  const currentIncident = useAppSelector(selectIncident);

  if (!incidentId) return null;
  if (incidentName) return incidentName;

  const listed = incidents.find((incident) => incident.id === incidentId)?.name;
  if (listed) return listed;
  if (currentIncident?.id === incidentId && currentIncident.name) {
    return currentIncident.name;
  }
  return null;
}
